
import React from 'react';
import { Hero } from '@/components/Hero';

export const HeroSection = () => {
  return <Hero />;
};
